'use client';

import { useDarkMode } from '@/lib/platform/contexts/dark-mode-context';

interface CheckboxProps {
  id: string;
  label: string | React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  required?: boolean;
  disabled?: boolean;
  error?: string;
}

export default function Checkbox({
  id,
  label,
  checked,
  onChange,
  required = false,
  disabled = false,
  error,
}: CheckboxProps) {
  const { darkMode } = useDarkMode();

  return (
    <div>
      <div className="flex items-start">
        <div className="flex h-6 items-center">
          <input
            id={id}
            name={id}
            type="checkbox"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            required={required}
            disabled={disabled}
            className={`size-4 rounded border focus:ring-2 focus:ring-offset-0 ${
              darkMode
                ? 'border-gray-600 bg-gray-700 text-indigo-500 focus:ring-indigo-500'
                : 'border-gray-300 text-indigo-600 focus:ring-indigo-600'
            } ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
          />
        </div>
        <div className="ml-3 text-sm/6">
          <label
            htmlFor={id}
            className={`font-medium ${
              darkMode ? 'text-gray-100' : 'text-gray-900'
            } ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
          >
            {label}
            {required && <span className="ml-1 text-red-500">*</span>}
          </label>
        </div>
      </div>
      {error && (
        <p className={`mt-2 text-sm ${darkMode ? 'text-red-400' : 'text-red-600'}`}>{error}</p>
      )}
    </div>
  );
}
